import { useEffect, useState } from 'react';

type DeviceType = 'mobile' | 'tablet' | 'desktop';

interface UseDeviceReturn {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  deviceType: DeviceType;
  screenWidth: number;
}

export const useDevice = (): UseDeviceReturn => {
  const getDeviceInfo = (): UseDeviceReturn => {
    const width = typeof window !== 'undefined' ? window.innerWidth : 0;
    const isMobile = width <= 768;
    const isTablet = width > 768 && width <= 1024;
    const isDesktop = width > 1024;

    let deviceType: DeviceType = 'desktop';
    if (isMobile) deviceType = 'mobile';
    else if (isTablet) deviceType = 'tablet';

    return {
      isMobile,
      isTablet,
      isDesktop,
      deviceType,
      screenWidth: width,
    };
  };

  const [deviceInfo, setDeviceInfo] = useState<UseDeviceReturn>(getDeviceInfo);

  useEffect(() => {
    const updateDeviceInfo = () => {
      setDeviceInfo(getDeviceInfo());
    };

    // Add event listener
    window.addEventListener('resize', updateDeviceInfo);

    // Cleanup
    return () => window.removeEventListener('resize', updateDeviceInfo);
  }, []);

  return deviceInfo;
};

export default useDevice;
